import React from "react";
import { Route, Routes } from "react-router-dom";
import AutoConnect from "./autoConnect";

const Base = (props: any) => {
  return (
    <Routes>
      <Route
        path="app/connect/:rtoken/:path/:email/:tenant"
        element={
          <React.Suspense fallback={<></>}>
            <AutoConnect />
          </React.Suspense>
        }
      />
      <Route path="*" element={props.children} />
    </Routes>
  );
};
export default Base;
